/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';

.PatientRecordFullEntry {
  width: 100%;

  .text-block {
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    padding: 10px 10px 20px 20px;
    .list-item-text {
      width: 1000px; // We need a specific width here to have ellipsis
      word-wrap: anywhere;
      -webkit-hyphens: auto;
      -moz-hyphens: auto;
      -ms-hyphens: auto;
      hyphens: auto;
    }

    .time {
      color: variables.$color-black-60;
    }

    .entry-title {
      max-width: 300px; // We need a specific width here to have ellipsis
      display: block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .entry-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  :hover {
    background-color: variables.$color-lightgrey;
  }
}
